import React from "react";
import {IonChip} from "@ionic/react";
import {Slot} from "../../models";


interface AvailabilityStatusChipsProps {
    actionsDisabled: boolean;
    slot: Slot;
    positionSlot?: string;
}

const SlotAvailabilityStatusChips: React.FC<AvailabilityStatusChipsProps> = ({slot, actionsDisabled, positionSlot}) => {
    if (!slot.isBooked && slot.availabilityDisplayStatuses && slot.availabilityDisplayStatuses.length > 0) {
        return (
            <>
                {slot.availabilityDisplayStatuses.map((displayStatus, iDisplayStatus) => (
                    <IonChip key={`slot-${slot.id}-availability-status-${iDisplayStatus}`}
                             disabled={actionsDisabled}
                             className={"chip-label"}
                             {...positionSlot && { slot: positionSlot }}
                             color={displayStatus.color}
                    >{displayStatus.text}</IonChip>
                ))}
            </>
        );
    } else {
        return null;
    }
};

export default SlotAvailabilityStatusChips;
